import { render, staticRenderFns } from "./MultiEditableLists.vue?vue&type=template&id=0c8a2954&scoped=true&"
import script from "./MultiEditableLists.vue?vue&type=script&lang=js&"
export * from "./MultiEditableLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a2954",
  null
  
)

export default component.exports